import cn from 'classnames'
import React from 'react'

//
import { SiteDataContext } from '../../components'
import CFRichText from '../../components/rich-text'

const RichText = ({ content = null, classes = '' }) => {
  const { isTextRtl } = React.useContext(SiteDataContext)
  if (!content) return null
  return (
    <div className={cn('s-wysiwyg-editor', classes, { 's-wysiwyg-editor--rtl': isTextRtl })}>
      <CFRichText data={content} />
    </div>
  )
}

export default RichText
